document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.luxury-slider', {
    slidesPerView: 1.1,
    spaceBetween: 12,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    breakpoints: {
      992: {
        slidesPerView: 1.5,
        spaceBetween: 12,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 12,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 12,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
      1450: {
        slidesPerView: 4.7,
        spaceBetween: 12,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      }
    }
  });

  const canvas = document.querySelector(".luxury-video__video");
  const context = canvas.getContext("2d");
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";

  const frameCount = isMobile ? 73 : 60;
  const to = isMobile ? 98 : 76;
  const from = isMobile ? 26 : 17;
  let loadedFrames = 0;
  const currentFrame = index => {
    let prefix = 'pc-';
    if (isMobile) {
      prefix = 'mobile-';
    }
    return `https://cdn.shopify.com/s/files/1/0669/6475/0628/files/${prefix}luxury-frame_${index}?v=1757419185`
  };

  const images = [];
  const imageSeq = { frame: 1 };
  for (let i = from, j = 1; i <= to; i++, j++) {
    const img = new Image();
    img.src = currentFrame(i);
    images.push(img);

    images[j - 1].onload = () => {
      loadedFrames++;
      if (j === 0) {
        render();
      }
    };
  }

  function render() {
    if (loadedFrames !== frameCount) {
      imageSeq.frame = 1;
    }

    const img = images[imageSeq.frame - 1];
    context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);

    const scale = Math.max(
      canvas.clientWidth / img.width,
      canvas.clientHeight / img.height
    );

    const drawWidth = img.width * scale * 1.01;
    const drawHeight = img.height * scale * 1.01;
    const x = (canvas.clientWidth - drawWidth) / 2;
    const y = (canvas.clientHeight - drawHeight) / 2;

    context.drawImage(img, x, y, drawWidth, drawHeight);
  }

  gsap.to(imageSeq, {
    frame: frameCount,
    snap: "frame",
    onUpdate: render,
    scrollTrigger: {
      trigger: '.luxury-video__video',
      scrub: 1,
      end: '+=110%',
      start: isMobile ? 'top+=100 bottom' : 'top+=300 bottom'
    }
  });

  function resizeCanvas() {
    const dpr = window.devicePixelRatio || 1;
    const cssWidth = canvas.clientWidth;
    const cssHeight = canvas.clientHeight;
    canvas.width = cssWidth * dpr;
    canvas.height = cssHeight * dpr;
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.scale(dpr, dpr);
    render();
  }

  window.addEventListener("resize", resizeCanvas);
  resizeCanvas();

  document.querySelectorAll('.luxury-block, .luxury-slider, .luxury-scroll').forEach(block => {
    ScrollTrigger.create({
      trigger: block,
      start: "top bottom",
      onEnter: () => {
        block.classList.add('active');
      },
      onLeaveBack: () => {
        block.classList.remove('active');
      }
    });
  });
});